import React from 'react'
import PropTypes from 'prop-types'

import { MenuItem } from '@material-ui/core'

/**
 * @param {{
 *    value?: any
 * }} props
 * @returns {React.Component}
 */
const ZariMenuItem = ({ value, ...props }) => {
  return <MenuItem {...props} value={value} />
}

ZariMenuItem.propTypes = {
  value: PropTypes.any
}

export default React.memo(ZariMenuItem)
